import React, { ReactNode } from "react";
import { Button, Modal, ModalProps } from "react-bootstrap";
import { useIntl } from "react-intl";

interface BaseModalProps extends ModalProps {
  showModal: boolean;
  closeModal?: () => void;
  closeSubModal?: () => void;
  header?: ReactNode;
  headerBody?: string;
  children?: ReactNode;
  footer?: ReactNode;
  footerBody?: ReactNode;
  triggerFunction?: () => void;
}

const BaseModal: React.FC<BaseModalProps> & {
  Body: React.FC<{ children?: ReactNode }>;
  Footer: React.FC<{ children?: ReactNode }>;
} = ({
  showModal,
  closeModal,
  closeSubModal,
  header,
  headerBody,
  children,
  footer,
  footerBody,
  ...modalProps
}) => {
  const intl = useIntl();

  return (
    <Modal show={showModal} onHide={closeModal} {...modalProps}>
      {header
        ? header
        : headerBody && (
            <Modal.Header closeButton>
              <Modal.Title>{headerBody}</Modal.Title>
            </Modal.Header>
          )}
      <Modal.Body className="pt-0 mt-0 pb-0 mb-0">{children}</Modal.Body>

      {footer !== null && (
        <Modal.Footer>
          <div
            className={`d-flex ${
              footerBody ? "justify-content-between" : "justify-content-end"
            } align-items-center w-100`}
          >
            {footerBody}
            <div>
              <Button
                variant="secondary"
                className="btn btn-sm btn-secondary ms-2"
                onClick={closeSubModal ? closeSubModal : closeModal}
              >
                {intl.formatMessage({ id: "MENU.DASHBOARD_PLANS_SALES.CLOSE" })}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

BaseModal.Body = ({ children }) => <>{children}</>;
BaseModal.Footer = ({ children }) => <>{children}</>;

export default BaseModal;
